import { useState, useEffect } from 'react';
import './Envelope.css';

export const Envelope = ({ onOpen }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const open = () => {
      setIsOpen(true);
      setTimeout(onOpen, 4000);
    };
    if (!isOpen) {
      window.addEventListener('click', open);
    }

    return () => {
      window.removeEventListener('click', open);
    };
  }, [isOpen]);

  useEffect(() => {
    let hideTimeout;
    if(isOpen)
      hideTimeout = setTimeout(() => setHide(true), 5500);
    return () => {
      if (hideTimeout) clearTimeout(hideTimeout);
    };
  }, [isOpen]);

  if (hide) return null;

  return (
    <>
      <div id="left" className={isOpen ? "open" : ""}>
        <img src="flowers.png" alt="flowers" className="decor" />
        
        <img id="stamp" src="flower-stamp.png" alt="flower-stamp" />
      </div>
      <div id="right" className={isOpen ? "open" : ""}>
        <img src="flowers.png" alt="flowers" className="decor" />
      </div>
    </>
    // <div className={`envelope ${isOpen ? 'open' : ''}`}>
    //     <div className={`panel top ${isOpen ? 'open' : ''}`}></div>
    //     <div className="panel left"></div>
    //     <div className="panel right"></div>
    //     <div className="panel bottom"></div>
    //     <div className={`panel heart ${isOpen ? 'open' : ''}`}><img src="floral-heart.png" alt="heart"  /></div>
    // </div>
  );
}